import React, {useState, useEffect, useRef} from 'react';
import {connect} from 'react-redux';

import Button from "../../ui/components/buttons/button";
import FormTextField from "../../ui/components/form-controls/form-text-field";

import {withRouter} from "react-router-dom";
import Visa from "../../assets/Visa.png";
import Master from "../../assets/Mastercard.png";
import "./payment.css"

import {
    checkValidity,
    _gaPushEvent,
    _gaPushData,
    _isNotDecimalChar,
    _sendLog,
    _getOccupationDesc
} from "../../utils/utility";
import {
    _getPolicy,
    _savePendingTransaction,
    _storePolicy,
    _logPaymentLifecycle,
    _issueAndReceiptPolicy
} from "../../store/policy/service";
import {_getSite, _getStep, _hideSpinner, _setStep, _showError, _showSpinner, _getPaynowAvailable} from "../../store/system/service";
import {useTranslation} from "react-i18next";
import moment from 'moment';
import Template from "../template";
import RadioBox from "../radio-box";
import {ReactComponent as PayByCC} from "../../assets/icon_credit_card_blue.svg";
import {ReactComponent as PayByPN} from "../../assets/icon_paynow.svg";
import QRCodeSample from "../../assets/QRCodeSample.png";
import {ReactComponent as PayNowLogo} from "../../assets/Paynow.svg";
import QrCode from "../qr-code-payment/qr-code";

const Payment = (props) => {
    const formRef = useRef(null);
    const buttonRef = useRef(null);
    const { t, i18n } = useTranslation();
    const paymentTypeSelectOptions = [
        {
            label: "Pay by Credit card",
            value: 'CC'
        },
        {
            label: "Pay by PayNow",
            value: 'PN'
        }
    ];
    const [paymentType, setPaymentType] = useState("CC");
    console.log("PaymentType =" + paymentType)
    // Temporary variable declaration
    const isPaynowAvailable = props.paynowAvailable;
    console.log("PaynowAvailable = "+isPaynowAvailable);

    useEffect(() => {
        window.paymentSuccess = paymentSuccess.bind(this);
        window.paymentError = paymentError.bind(this);
        props.setStep(3);
    }, [props.policy]);

    const [payment, setPayment] = useState({
        cardHolderName: '',
        cardNumber: '',
        expiryDate: '',
        cvv: '',
        errorMessage: {
            cardHolderNameError: '',
            cardNumberError: '',
            expiryDateError: '',
            cvvError: '',
            paymentErrorMessage: ''
        },
        paymentSignature: {}
    });

    useEffect(() => {
        checkFormIfValid();
    },[payment]);

    const back = () => {
        props.history.goBack();
    };

    const checkFormIfValid = () => {
        let formState = true;
        if (payment.cardHolderName && payment.expiryDate && payment.cardNumber && payment.cvv) {
            let errorMsgObj = payment.errorMessage;
            for (let keys in errorMsgObj) {
                if (errorMsgObj[keys]) {
                    formState = false;
                    break;
                }
            }
        } else {
            formState = false;
        }

        buttonRef.current.disabled = formState ? false : true;
    };

    const changeInputHandler = (changesObj) => {
        let newObj = {...payment};
        for (let key in changesObj) {
            newObj[key] = changesObj[key];
        }

        setPayment(newObj);
    };

    const onChangeCardNumberFormatHandler = (event) => {
        let cardNoRegex = new RegExp("^\\d{4}-\\d{4}-\\d{4}-\\d{4}$", "g");
        let newCardNo = '';
        let preventDefault = false;
        if (!cardNoRegex.test(event.target.value)) {
            let cardNo = event.target.value.replace(/-/g, '');
            if (cardNo.length > 16) {
                cardNo = cardNo.substring(0, 16);
            }

            if (!(/\D/g.test(cardNo))) {
                do {
                    if (cardNo.length > 4) {
                        newCardNo = newCardNo + cardNo.substring(0, 4) + '-';
                        cardNo = cardNo.substring(4, cardNo.length);
                    } else {
                        newCardNo = newCardNo + cardNo;
                        cardNo = '';
                    }
                } while (cardNo.length > 0);
            } else {
                preventDefault = true;
            }
        } else {
            newCardNo = event.target.value;
        }

        if (!preventDefault){
            changeInputHandler({cardNumber: newCardNo});
        } else {
            event.preventDefault();
        }
    };

    const onChangeExpiryDateHandler = (event) => {
        let newExpiryDate = event.target.value.trim();
        if (newExpiryDate) {
            if (newExpiryDate.length === 4 && newExpiryDate.indexOf("-") === -1) {
                newExpiryDate = newExpiryDate.substring(0, 2) + '-' + newExpiryDate.substring(2);
            }
        }
        let changesObject = {};
        changesObject['expiryDate'] = newExpiryDate;
        changeInputHandler(changesObject);
    };

    const expiryDateValidator = (dateString) => {
        if (dateString.length === 5) {
            const dateArr = dateString.split('-');
            if (dateArr[0] > 12 || dateArr[0] < 1) {
                return false;
            }

            const currentYr = moment().format('YY').toString();
            if (dateArr[1] < currentYr){
                return false;
            } else if (dateArr[1] == currentYr){
                const currentMon = moment().format('MM').toString();
                if (dateArr[0] < currentMon){
                    return false;
                }
            }
        }

        const expiryDateRgx = new RegExp("^\\d{2}-\\d{2}$", "g");
        if (!expiryDateRgx.test(dateString)){
            return false;
        }

        return true;
    };

    const fieldValidatorHandler = (value, errMsgProp, validationProps) => {
        let errorMessageObject = {...payment.errorMessage};
        errorMessageObject[errMsgProp] = '';
        let changesObject = {};

        for (let props in validationProps) {
            let isInvalid = false;
            if (props === 'required') {
                if (!checkValidity(value, {required: true})) {
                    isInvalid = true;
                    errorMessageObject[errMsgProp] = validationProps[props].message;
                } else {
                    errorMessageObject[errMsgProp] = '';
                }
            } else if (props === 'minLength') {
                if (!checkValidity(value.replace(/-/g, ''), {minLength: validationProps[props].value})) {
                    isInvalid = true;
                    errorMessageObject[errMsgProp] = validationProps[props].message;
                } else {
                    errorMessageObject[errMsgProp] = '';
                }
            } else if (props === 'expiryDateValidator') {
                if (!expiryDateValidator(value)) {
                    isInvalid = true;
                    errorMessageObject[errMsgProp] = validationProps[props].message;
                } else {
                    errorMessageObject[errMsgProp] = '';
                }
            } else if (props === 'firstAndLastName') {
                if (!firstAndLastNameValidator(value)) {
                    isInvalid = true;
                    errorMessageObject[errMsgProp] = validationProps[props].message;
                } else {
                    errorMessageObject[errMsgProp] = '';
                }
            } else if (props === 'cvvFormat') {
                const cvvRegex = new RegExp("^\\d{3}$", "g");
                if (!cvvRegex.test(value)){
                    isInvalid = true;
                    errorMessageObject[errMsgProp] = validationProps[props].message;
                } else {
                    errorMessageObject[errMsgProp] = '';
                }
            }
            //break loop if found invalid
            if (isInvalid) {
                break;
            }
        }
        changesObject.errorMessage = errorMessageObject;
        changeInputHandler(changesObject);
    };

    const firstAndLastNameValidator = (value) => {
        const arr = value.trim().split(" ");
        return arr.length > 1 ? true : false;
    }

    const processPayment = () => {
        _gaPushEvent('Pay');
        props.showSpinner();

        props.policy.payment = {
            paymentCreditCardName: payment.cardHolderName
        };
        props.storePolicy(props.policy);

        props.callSavePendingTransaction(props.policy).then((result) => {
            if (result?.policy?.errorMessage === '' || result?.policy?.errorMessage == null) {
                let changesObject = {};
                changesObject.paymentSignature = result.paymentSignature;

                let cardType = '001';
                let expiryDate = payment.expiryDate.substring(0, 2) + "-20" + payment.expiryDate.substring(3);
                let cardNumber = '';

                if (payment.cardNumber) {
                    cardNumber = payment.cardNumber.replace(/\s/g, '').replace(/-/g, '');
                    if (new RegExp('^5[1-5]*').test(cardNumber)) {
                        cardType = '002';
                    }
                }

                changesObject.paymentSignature.cardType = cardType;
                changesObject.paymentSignature.expiryDate = expiryDate;
                changesObject.paymentSignature.cardNumber = cardNumber;
                changeInputHandler(changesObject);
                formRef.current.submit();
            } else {
                props.hideSpinner();
                props.showError([result.policy.errorMessage]);
            }
        }, (error) => {
            props.hideSpinner();
            props.showError([error?.response?.data?.message]);
        });
    };

    const paymentSuccess = (referenceNumberToken, referenceNumber, auth_code) => {
        console.log('Payment successful. Reference Number '
            + referenceNumber + ' referenceNumberToken:' + referenceNumberToken + ' auth_code:' + auth_code);
        
        _sendLog('SME-React - paymentSuccess - Payment successful. Reference Number '
            + referenceNumber + ' referenceNumberToken:' + referenceNumberToken + ' auth_code:' + auth_code, 'info');

        props.policy.payment = {
            paymentReferenceNumber: referenceNumber,
            paymentReferenceNumberToken: referenceNumberToken,
            auth_code: auth_code
        };

        props.storePolicy(props.policy);
        paymentGatewaySuccessReturn();
    };

    const paymentGatewaySuccessReturn = () => {
        console.log('paymentGatewaySuccessReturn');
        props.callIssueAndReceiptPolicy(props.policy).then(() => {
            props.hideSpinner();
            console.log('Policy issue success');
            _sendLog('SME-React - paymentGatewaySuccessReturn - Policy issue success', 'info');
            props.history.push((props.site ? '/' + props.site : '') + '/finish');
        }, err => {
            props.hideSpinner();
            props.showError(['Error While doing policy issue receipt', err]);
        });
    };

    const paymentError = (referenceNumber, message, invalidFields, reasonCode) => {
        console.error('Payment error !!!! Reference Number '
            + referenceNumber + ' message '
            + message + ' invalidFields:'
            + invalidFields + ' reasonCode ' + reasonCode);

        _sendLog('SME-React - Payment error !!!! Reference Number '
            + referenceNumber + ' message '
            + message + ' invalidFields: '
            + invalidFields + ' reasonCode ' + reasonCode)

        let errorMsg;

        if (reasonCode === '201' || reasonCode === '200' || reasonCode === '230' || reasonCode === '520') {
            errorMsg = 'Transaction was declined. Please try again. (Reference Number: ' + referenceNumber + ')';
        } else if (reasonCode === '202' || reasonCode === '203' || reasonCode === '204' ||
            reasonCode === '205' || reasonCode === '207' || reasonCode === '208' || reasonCode === '210' ||
            reasonCode === '211' || reasonCode === '221' || reasonCode === '222' || reasonCode === '231' ||
            reasonCode === '232' || reasonCode === '233' || reasonCode === '234' || reasonCode === '236' ||
            reasonCode === '240' || reasonCode === '475' || reasonCode === '476') {
            errorMsg = 'Authorization was declined. Please review payment details. (Reference Number: ' + referenceNumber + ')';
        } else if (reasonCode === '104' || reasonCode === '150' || reasonCode === '151' || reasonCode === '152') {
            errorMsg = 'Transaction was declined. Please try again. (Reference Number: ' + referenceNumber + ')';
        } else {
            errorMsg = 'Transaction was declined. Please try again. (Reference Number: ' + referenceNumber + ')';
        }

        props.hideSpinner();
        //show popup for error message
        props.showError([errorMsg]);


        props.callLogPaymentLifecycle(props.policy).then(() => {
            console.log('payment lifecycle added ');
        }, (err) => {
            console.log('_logPaymentLifecycle failed: ' + err);
            _sendLog('SME-React - paymentError - _logPaymentLifecycle failed: ' + err)
        });
    };

    const getDates = () => {
        const inceptionDateString = moment(props.policy?.policySME?.inceptionDate, 'DD/MM/YYYY', true)
            .format('DD/MM/YY').toString();
        const expiryDateString = moment(props.policy?.policySME?.expiryDate, 'DD/MM/YYYY', true)
            .format('DD/MM/YY').toString();

        return inceptionDateString.concat(' - ').concat(expiryDateString) ;
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        _gaPushData({
            'pageStep': 'Pay',
            'vPath': '/pay',
            'event': 'vpageview',
            'ecommerce': {
                'checkout': {
                    'actionField': {
                        'step': 4, 
                        'option': _getOccupationDesc(props.policy.policySME.occupationCode)
                    }
                }
		    }
        });
    }, []);

    return (
        <Template payment step={props.step} policy={props.policy} site={props.site} prevPage="/application/confirm">

                    <div className="PaymentEffectiveDateStyle">
                        <p>SME Business Insurance</p>
                        <p>{getDates()}</p>
                        <div className={"divider " +(isPaynowAvailable === true ? "elementHidden" :"")}></div>
                    </div>

                    {isPaynowAvailable === true &&
                    <div className="PaymentSelectContainer">
                        <div className="PaymentSelectTitle">SSelect a payment method</div>
                        <div className="payTypeIcon payByCC"><PayByCC/></div>
                        <div className="payTypeIcon payByPN"><PayByPN/></div>
                        <RadioBox
                            options={paymentTypeSelectOptions}
                            value={paymentType}
                            onClick={(value) => setPaymentType(value)}
                        />
                    </div>
                    }

                    <div className="PaymentTotalAmount">
                        <p className="label">TOTAL AMOUNT</p>
                        <p className="amount">SGD${props.policy?.policySME?.totalDueAmount}</p>
                    </div>

                    {paymentType === "CC" &&
                    <div className="PaymentCCBoxStyle">
                        <div className="ccIconContainer"><img className="PaymentVisaIconStyle" src={Visa}/></div>
                        <div className="ccIconContainer"><img className="PaymentMasterIconStyle" src={Master}/></div>
                    </div>
                    }

                    {paymentType === "CC" &&
                    <div className="PaymentInputGroupsStyle">
                        <div className="PaymentInputGroupStyle">
                            <div className="PaymentInputBoxStyle">
                                <FormTextField
                                    label="Card Holder Name"
                                    value={payment.cardHolderName}
                                    errorMessage={payment.errorMessage.cardHolderNameError}
                                    onChange={(event) => {
                                        if (/[^a-zA-Z\s]/g.test(event.target.value)){
                                            event.preventDefault();
                                        } else {
                                            changeInputHandler({cardHolderName: event.target.value.toUpperCase()})
                                        }
                                    }}
                                    onBlur={(event) =>
                                        fieldValidatorHandler(event.target.value, 'cardHolderNameError',
                                            {
                                                required: {
                                                    value: true,
                                                    message: t("payment.cardHolderName.validationMessage.required")
                                                },
                                                firstAndLastName: {
                                                    value: true,
                                                    message: t("payment.cardHolderName.validationMessage.firstAndLastName")
                                                }
                                            })}
                                    maxLength={30}
                                >
                                </FormTextField>
                            </div>
                        </div>

                        <div className="PaymentInputGroupStyle">
                            <div className="PaymentInputBoxStyle">
                                <FormTextField
                                    label="Card Number"
                                    value={payment.cardNumber}
                                    errorMessage={payment.errorMessage.cardNumberError}
                                    inputMode={'numeric'}
                                    onChange={(event) => onChangeCardNumberFormatHandler(event)}
                                    onKeyPress={(event) => {
                                        if (_isNotDecimalChar(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    onBlur={(event) =>
                                        fieldValidatorHandler(event.target.value, 'cardNumberError',
                                            {
                                                required: {
                                                    value: true,
                                                    message: t("payment.creditCardNumber.validationMessage.required")
                                                },
                                                minLength: {
                                                    value: 16,
                                                    message: t("payment.creditCardNumber.validationMessage.minLength")
                                                        .concat('16 digit character')
                                                }
                                            })}
                                    maxLength={19}
                                >
                                </FormTextField>
                            </div>
                        </div>

                        <div className="PaymentInputGroupStyle">
                            <div className="PaymentInputBoxStyle">
                                <FormTextField
                                    label="Expiry Date"
                                    value={payment.expiryDate}
                                    inputMode={'numeric'}
                                    onChange={(event) => onChangeExpiryDateHandler(event)}
                                    onKeyPress={(event) => {
                                        if (_isNotDecimalChar(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    placeHolder="MM-YY"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    errorMessage={payment.errorMessage.expiryDateError}
                                    onBlur={(event) =>
                                        fieldValidatorHandler(event.target.value, 'expiryDateError',
                                            {
                                                required: {
                                                    value: true,
                                                    message: t("payment.expiryDate.validationMessage.required")
                                                },
                                                expiryDateValidator: {
                                                    value: true,
                                                    message: t("payment.expiryDate.validationMessage.expiryDtValid")
                                                }
                                            })}
                                    maxLength={5}
                                >
                                </FormTextField>
                            </div>
                        </div>

                        <div className="PaymentInputGroupStyle">
                            <div className="PaymentInputBoxStyle">
                                <FormTextField
                                    label="CVV"
                                    value={payment.cvv}
                                    inputMode={'numeric'}
                                    onChange={(event) => changeInputHandler({cvv: event.target.value.trim()})}
                                    onKeyPress={(event) => {
                                        if (_isNotDecimalChar(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    errorMessage={payment.errorMessage.cvvError}
                                    onBlur={(event) =>
                                        fieldValidatorHandler(event.target.value, 'cvvError',
                                            {
                                                required: {
                                                    value: true,
                                                    message: t("payment.cvv.validationMessage.required")
                                                },
                                                minLength: {
                                                    value: 3,
                                                    message: t("payment.cvv.validationMessage.cvvFormat")
                                                },
                                                cvvFormat: {
                                                    message: t("payment.cvv.validationMessage.cvvFormat")
                                                }
                                            })}
                                    maxLength={3}
                                >
                                </FormTextField>
                            </div>
                        </div>
                    </div>
                    }

                    {paymentType === "PN" && isPaynowAvailable === true &&
                    <div className="payNowContainer">
                        <div className="PayNowLogoContainer">
                            <PayNowLogo/>
                        </div>
                        <div className="PayNowInstruction">Please scan QR code to pay</div>
                        <div className="PayNowQRCodeContainer">
                            <div className="qr-code">
                                <QrCode />
                            </div>
                        </div>
                    </div>
                    }
                    
                    <div className={"PaymentInputButtonsGroupStyle " +(paymentType === 'PN' ? "elementHidden" :"")}>
                        <div className="PaymentInputButtonsStyle">
                            <Button color="primary" ref={buttonRef} onClick={processPayment}>Pay</Button>
                        </div>
                    </div>

                <div className="PaymentIFrameStyle">
                    <form ref={formRef} target="payment_iframe" action={payment.paymentSignature.paymentUrl}
                          method="post">
                        <input type="hidden" id="access_key" name="access_key"
                               value={payment.paymentSignature?.access_key || ''}/>
                        <input type="hidden" id="profile_id" name="profile_id"
                               value={payment.paymentSignature?.profile_id || ''}/>
                        <input type="hidden" id="transaction_uuid"
                               name="transaction_uuid" value={payment.paymentSignature?.transaction_uuid || ''}/>
                        <input type="hidden" id="signed_field_names" name="signed_field_names"
                               value={payment.paymentSignature?.signed_field_names || ''}/>
                        <input type="hidden" id="unsigned_field_names" name="unsigned_field_names"
                               value={payment.paymentSignature?.unsigned_field_names || ''}/>
                        <input type="hidden" id="signed_date_time" name="signed_date_time"
                               value={payment.paymentSignature?.signed_date_time || ''}/>
                        <input type="hidden" id="locale" name="locale" value={payment.paymentSignature?.locale || ''}/>
                        <input type="hidden" id="transaction_type" name="transaction_type"
                               value={payment.paymentSignature?.transaction_type || ''}/>
                        <input type="hidden" id="reference_number" name="reference_number"
                               value={payment.paymentSignature?.reference_number || ''}/>
                        <input type="hidden" id="amount" name="amount"
                               value={payment.paymentSignature?.amount || ''}/>
                        <input type="hidden" id="currency" name="currency"
                               value={payment.paymentSignature?.currency || ''}/>
                        <input type="hidden" id="payment_method" name="payment_method"
                               value={payment.paymentSignature?.payment_method || ''}/>
                        <input type="hidden" id="bill_to_forename" name="bill_to_forename"
                               value={payment.paymentSignature?.bill_to_forename || ''}/>
                        <input type="hidden" id="bill_to_surname" name="bill_to_surname"
                               value={payment.paymentSignature?.bill_to_surname || ''}/>
                        <input type="hidden" id="bill_to_email" name="bill_to_email"
                               value={payment.paymentSignature?.bill_to_email || ''}/>
                        <input type="hidden" id="bill_to_phone" name="bill_to_phone"
                               value={payment.paymentSignature?.bill_to_phone || ''}/>
                        <input type="hidden" id="bill_to_address_line1" name="bill_to_address_line1"
                               value={payment.paymentSignature?.bill_to_address_line1 || ''}/>
                        <input type="hidden" id="bill_to_address_city" name="bill_to_address_city"
                               value={payment.paymentSignature?.bill_to_address_city || ''}/>
                        <input type="hidden" id="bill_to_address_state"
                               name="bill_to_address_state"
                               value={payment.paymentSignature?.bill_to_address_state || ''}/>
                        <input type="hidden" id="bill_to_address_country" name="bill_to_address_country"
                               value={payment.paymentSignature?.bill_to_address_country || ''}/>
                        <input type="hidden" id="bill_to_address_postal_code" name="bill_to_address_postal_code"
                               value={payment.paymentSignature?.bill_to_address_postal_code || ''}/>
                        <input type="hidden" id="override_custom_receipt_page" name="override_custom_receipt_page"
                               value={payment.paymentSignature?.override_custom_receipt_page || ''} />
                        <input type="hidden" id="signature" name="signature"
                               value={payment.paymentSignature?.paymentSignatureKey || ''}/>
                        <input type="hidden" id="card_type" name="card_type"
                               value={payment.paymentSignature?.cardType || ''}/>
                        <input type="hidden" id="card_number" name="card_number"
                               value={payment.paymentSignature?.cardNumber || ''}/>
                        <input type="hidden" id="card_expiry_date" name="card_expiry_date"
                               value={payment.paymentSignature?.expiryDate || ''}/>
                        <input type="hidden" id="card_cvn" name="card_cvn" value={payment.cvv || ''}/>
                    </form>

                    <iframe name="payment_iframe" src="" width="100" height="0" frameBorder="0"></iframe>
                </div>
        </Template>
    )
};


const mapStateToProps = state => {
    return {
        policy: _getPolicy(state),
        step: _getStep(state),
        site: _getSite(state),
        paynowAvailable: _getPaynowAvailable(state)
    };
}

const mapDispatchToProps = {
    callSavePendingTransaction: _savePendingTransaction,
    storePolicy: _storePolicy,
    callLogPaymentLifecycle: _logPaymentLifecycle,
    callIssueAndReceiptPolicy: _issueAndReceiptPolicy,
    setStep: _setStep,
    showError: _showError,
    showSpinner: _showSpinner,
    hideSpinner: _hideSpinner
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Payment));
